<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <span class="text-muted text-uppercase">
          <span v-if="sample_type">
            {{ sample_type.name }} <i class="fa fa-minus" />
          </span>
          <span v-if="test_package_group">
            {{ test_package_group.name }} <i class="fa fa-minus" />
          </span>
          <span>
            {{ test_package.name }}
          </span>
        </span>
      </b-card-header>
      <b-card-body>
        {{ test_package.description }}
        <b-card-text>
          <label>Cost:</label>
          {{ test_package.cost ? formatCost(test_package.cost) : "Not specified" }}
        </b-card-text>
        <b-card-text>
          <label>Add-On Cost:</label>
          {{
            test_package.cost_add_on
              ? formatCost(test_package.cost_add_on)
              : "Not specified"
          }}
        </b-card-text>
        <b-card-text v-if="test_package.internal">
          <label>Internal:</label>
          {{ test_package.internal ? "Yes" : "No" }}
        </b-card-text>
      </b-card-body>
      <b-list-group v-model="test_package_samples" flush>
        <b-list-group-item
          v-for="(item, item_index) in test_package_samples"
          :key="item_index"
        >
          <label class="font-weight-bold"> {{ item.name }}: </label>
          <span
            v-for="(subitem, subitem_index) in test_package_samples[item_index][
              'analytes'
            ]"
            :key="subitem_index"
          >
            {{
              formatSampleAnalyte(
                subitem,
                subitem_index,
                test_package_samples[item_index]["analytes"].length
              )
            }}
          </span>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
import TestPackageModel from "@/models/lab/TestPackageModel";

export default {
  name: "TestPackageCard",
  props: {
    test_package: {
      type: Object,
      default: () => new TestPackageModel()
    }
  },
  computed: {
    sample_type() {
      return this.test_package.sample_type;
    },
    test_package_group() {
      return this.test_package.test_package_group;
    },
    test_package_samples() {
      return this.test_package.test_package_samples;
    }
  },
  methods: {
    formatSampleAnalyte(analyte, index, count) {
      return `${analyte.abbrev}${index + 1 < count ? ", " : ""}`;
    },
    formatCost(cost) {
      if (typeof cost !== "undefined") {
        return "$" + cost;
      } else {
        return "N/A";
      }
    }
  }
};
</script>
